import { useQueryClient } from '@tanstack/vue-query'

export default function useInvalidateQueries(keys: (string | string[])[]) {
  const queryClient = useQueryClient()

  return () => {
    keys.forEach((key) => queryClient.invalidateQueries({ queryKey: Array.isArray(key) ? key : [key] }))
  }
}
